import React, { Component } from 'react';
import './Cart--Item.css';

//import Input from './Input';

class CartShipping extends Component {

  constructor(props) {
    super(props);

    this._updateQuantity = this._updateQuantity.bind(this);

    this.state = {
      
    };

  }

  componentWillReceiveProps(newProps) {

    this.setState({
      
    });

  }

  render() {
    
    var shippingMessageStyle = {};
    if (!this.props.shippingMessage) {
      shippingMessageStyle.display = "none";
    }    

    return (
      
      <div className="Page cartRow"> 

        <div className="cartRow-info clearflex align-flex-start">
          <div className="two-thirds column">
            <p><strong>{this.props.name}</strong></p>
          </div>
          <div className="one-third column">
            <p><span className="total">{this.props.price ? "$"+this.props.price.toFixed(2) : <strong>Free</strong>}</span></p>
          </div>
        </div>

        <p className="cartRow-footer" style={shippingMessageStyle}>{this.props.shippingMessage} <a href={"mailto:"+this.props.storeEmail} target="_blank">Questions?</a></p>

      </div>
            
    );  
  
  }

  _updateQuantity(quantity) {
    console.log(quantity);
  }

}

export default CartShipping;


// WEBPACK FOOTER //
// ./src/components/Cart--Shipping.js